import styled from 'styled-components';
import { FormControl, Select } from '@mui/material';

import colors from '../../../../styles/colors';

const StyledFormControl = styled(FormControl)`
  && {
    margin: 0 10px;
    min-width: auto;
  }
`;

const StyledSelect = styled(Select)`
  && {
    font-size: 14px;
    font-weight: 500;
    padding: 0;
    border-radius: 36px;
    background-color: ${colors.base.alpha};
    border: 1px solid ${colors.shades.secondary6};
    color: ${colors.base.secondary2};
    height: 32px;

    .MuiSelect-select {
      padding: 5px 32px 5px 15px;
      display: flex;
      align-items: center;
    }

    .MuiOutlinedInput-notchedOutline {
      border: none;
    }

    &:hover {
      background-color: ${colors.shades.secondary5};
    }

    &.Mui-focused {
      background-color: ${colors.shades.secondary5};

      .MuiOutlinedInput-notchedOutline {
        border: none;
      }
    }

    .MuiSvgIcon-root {
      color: ${colors.base.secondary2};
    }
  }
`;

export {
  StyledFormControl,
  StyledSelect,
};
